import { useEffect, useState } from "react";
import { toast } from "sonner";
import api, { formatApiError } from "@/lib/api";
import { PageHeader, Surface, Button, Modal, Input, Select, NewButton } from "@/components/ui-kit";

const empty = { name: "", type: "depot", address: "" };

export default function Locations() {
    const [list, setList] = useState([]);
    const [open, setOpen] = useState(false);
    const [form, setForm] = useState(empty);
    const [editing, setEditing] = useState(null);

    const load = () => api.get("/locations").then((r) => setList(r.data));
    useEffect(() => { load(); }, []);

    const save = async () => {
        try {
            if (editing) await api.put(`/locations/${editing}`, form);
            else await api.post("/locations", form);
            toast.success("Saved"); setOpen(false); setEditing(null); setForm(empty); load();
        } catch (e) { toast.error(formatApiError(e.response?.data?.detail)); }
    };
    const edit = (l) => { setForm({ ...empty, ...l }); setEditing(l.id); setOpen(true); };
    const del = async (id) => { if (!window.confirm("Delete?")) return; await api.delete(`/locations/${id}`); load(); };

    return (
        <div className="p-6 lg:p-8 animate-fade-in">
            <PageHeader
                eyebrow="NETWORK"
                title="Locations"
                subtitle={`${list.length} depots / warehouses / workshops`}
                action={<NewButton onClick={() => { setForm(empty); setEditing(null); setOpen(true); }} label="Add location" testid="add-location-btn" />}
            />

            <Surface className="overflow-hidden">
                <table className="w-full text-sm">
                    <thead className="bg-slate-50"><tr className="text-left">
                        {["NAME", "TYPE", "ADDRESS", ""].map((h) => <th key={h} className="label-mono px-5 py-3 font-normal">{h}</th>)}
                    </tr></thead>
                    <tbody>
                        {list.map((l) => (
                            <tr key={l.id} className="border-t border-fleet-border data-grid-row">
                                <td className="px-5 py-3 font-medium">{l.name}</td>
                                <td className="px-5 py-3 capitalize">{l.type}</td>
                                <td className="px-5 py-3 text-fleet-inkSoft">{l.address || "—"}</td>
                                <td className="px-5 py-3 text-right">
                                    <Button variant="ghost" size="sm" onClick={() => edit(l)} data-testid={`edit-loc-${l.id}`}>Edit</Button>
                                    <Button variant="ghost" size="sm" onClick={() => del(l.id)} data-testid={`del-loc-${l.id}`}>Del</Button>
                                </td>
                            </tr>
                        ))}
                        {list.length === 0 && <tr><td colSpan={4} className="px-5 py-10 text-center text-sm text-fleet-inkSoft">No locations yet.</td></tr>}
                    </tbody>
                </table>
            </Surface>

            <Modal open={open} onClose={() => setOpen(false)} title={editing ? "Edit location" : "Add location"}
                footer={<><Button variant="secondary" onClick={() => setOpen(false)}>Cancel</Button><Button onClick={save}>Save</Button></>}>
                <div className="grid grid-cols-2 gap-4">
                    <Input label="Name" className="col-span-2" value={form.name} onChange={(e) => setForm({ ...form, name: e.target.value })} />
                    <Select label="Type" value={form.type} onChange={(e) => setForm({ ...form, type: e.target.value })} options={["depot", "warehouse", "workshop"]} />
                    <Input label="Address" value={form.address} onChange={(e) => setForm({ ...form, address: e.target.value })} />
                </div>
            </Modal>
        </div>
    );
}
